import { useMemo } from 'react';
import { type GroupBase } from 'react-select';
import { AsyncPaginate } from 'react-select-async-paginate';
import ReactAsyncSelect from 'react-select/async';

import { SelectLoadError } from './SelectLoadError';
import { type AsyncOption, type AsyncSelectProps } from './types';
import { useAsyncSelectProps } from './useAsyncSelectProps';

export function AsyncSelect<TItem, TPageParam = number, TFilters = undefined>(
  props: AsyncSelectProps<TItem, TPageParam, TFilters>,
) {
  const {
    commonProps,
    control,
    debounceTimeout,
    filtersKey,
    loadError,
    shouldLoadMore,
    testId,
  } = useAsyncSelectProps(props, { isCreatable: false });
  const cacheUniqs = useMemo(() => [filtersKey], [filtersKey]);

  return (
    <div data-testid={testId}>
      {control.isPaginated ? (
        <AsyncPaginate<
          AsyncOption<TItem>,
          GroupBase<AsyncOption<TItem>>,
          { pageParam?: TPageParam },
          boolean
        >
          key={filtersKey}
          {...commonProps}
          additional={control.additional}
          cacheUniqs={cacheUniqs}
          debounceTimeout={debounceTimeout}
          loadOptions={control.loadPaginatedOptions}
          shouldLoadMore={shouldLoadMore}
        />
      ) : (
        <ReactAsyncSelect<
          AsyncOption<TItem>,
          boolean,
          GroupBase<AsyncOption<TItem>>
        >
          key={filtersKey}
          {...commonProps}
          loadOptions={control.loadOptions}
        />
      )}
      <SelectLoadError error={loadError} />
    </div>
  );
}
